export default __webpack_public_path__ + "static/media/icon-copy.4ee05e2c.svg";